import React from 'react';
import { RegisterOptions } from 'react-hook-form/dist/index.ie11';
import { BaseEmailInput } from 'src/components/BaseEmailInput/BaseEmailInput';
import { addAsterisk } from 'src/components/enterprise/features/Corporate/components/Form/utils/addAsterisk';

export interface InvoiceContactEmailControlProps {
  name: string;
  id: string;
  rules?: RegisterOptions;
}

export function InvoiceContactEmailControl({
  name,
  id,
  rules,
}: InvoiceContactEmailControlProps): JSX.Element {
  return (
    <BaseEmailInput
      name={name}
      id={id}
      label={addAsterisk('Email', rules)}
      rules={rules}
    />
  );
}
